import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DuplicateAddPoolService {

  constructor() { }

   public behaviourservice:any = new BehaviorSubject(null)
   public $planeservice:Observable<any>=this.behaviourservice.asObservable();

  getValuefromForm(event:any){
    return this.behaviourservice.next(event)
  }
}
